import Vue from 'vue'

const state = {
  texts: {}
}

const getters = {
  InfoText: state => key => state.texts[key]
}

const actions = {
  getInfoText ({ commit }, packet) {
    // packet.data is { key: "...", content: "..." }
    commit('setInfoText', packet.data)
  }
}

const mutations = {
  setInfoText (state, { key, content }) {
    Vue.set(state.texts, key, content)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
